import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {
  faFacebookF,
  // faTwitter,
  // faInstagram,
  // faPinterestP,
  // faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Images } from '../../../assets/assets';
import { useContactStore } from '../../../store/useContactStore';
import { formatPhoneNumberWithDash } from '../../../helper';

const TopHeader = () => {
  let { getContactInfo, contact } = useContactStore()
  const socialLinks = [
    { icon: faFacebookF, url: "https://www.facebook.com/5StarGrading/", name: "Facebook", fieldName: 'facebookLink' },
    // { icon: faTwitter, url: "https://twitter.com", name: "Twitter" },
    // { icon: faInstagram, url: "https://instagram.com", name: "Instagram" },
    // { icon: faPinterestP, url: "https://pinterest.com", name: "Pinterest" },
    // { icon: faYoutube, url: "https://youtube.com", name: "YouTube" },
  ];


  const fetchContactPage = async () => {
    if (contact) return

    await getContactInfo()
  }

  useEffect(() => {
    fetchContactPage()
  }, [])
  return (
    <div className='top-header-wraper'>
      <Container className='theme-container'>
        <Row className="align-items-center">
          {/* Left: Social Icons */}
          <Col xs="auto" className="ms-3">
            <ul className="top-header-social-links list-unstyled d-flex gap-2 mb-0">
              {socialLinks
                .filter((link) => contact?.[link.fieldName])
                .map(({ icon, name, fieldName }, index) => (
                  <li key={index}>
                    <a
                      href={contact[fieldName]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-icon d-flex justify-content-center align-items-center rounded-circle"
                      aria-label={name}
                      title={name}
                    >
                      <FontAwesomeIcon icon={icon} size="sm" />
                    </a>
                  </li>
                ))}
            </ul>
          </Col>

          {/* Center: Text */}
          <Col className="text-center">
            <p className='fs-6'>
              Veteran-Owned, Insured, and Bonded Civil Contractor
            </p>

          </Col>

          {/* Right: Phone */}
          <Col xs="auto" className="d-flex align-items-center">
            <div className='top-header-contact-block cursor-pointer'>
              <img className="img-fluid me-2" src={Images.PhoneIcon} alt="Phone icon" />
              <span className="fw-bold">{formatPhoneNumberWithDash(contact?.phoneNumber)}</span>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TopHeader;
